import { LayoutView } from '../../components/Layout/Layout'

export const CalendarPage = () => {
  return (
    <LayoutView mainContent={<div className='p-4'>Calendar</div>} />
  )
}